// extracted by mini-css-extract-plugin
export default {"subtitle":"PersonalizationTag_subtitle__GXNo6"};